import { render } from "./AudiosPage.vue?vue&type=template&id=2052273a"
import script from "./AudiosPage.vue?vue&type=script&lang=js"
export * from "./AudiosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__